const debounce = require("lodash/debounce");

/**
 *  Init carousel for content  tiles
 */
const initCarousel = (carousel) => {
    if (carousel && carousel.length) {
        carousel.each(function () {
            const $this = $(this);
            const slidesSm = $this.data("slides-small");
            const slidesMd = $this.data("slides-medium");
            const slidesLg = $this.data("slides-large");
            const arrows = $this.data("slides-arrows");
            const dots = $this.data("slides-dots");
            const baseConfig = {
                prevArrow: "<button type='button' class='slick-prev slick-arrow-border slick-prev-out' aria-label='Previous'></button>",
                nextArrow: "<button type='button' class='slick-next slick-arrow-border slick-next-out' aria-label='Next'></button>",
                "slidesToShow": slidesSm,
                pauseOnFocus: false,
                mobileFirst: true,
                arrows:  arrows,
                adaptiveHeight: true,
                dots: dots,
                responsive: [
                    {
                        breakpoint: 544,
                        settings: {
                            slidesToShow: slidesMd
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: slidesLg,
                            arrows: arrows
                        }
                    }
                ]
            };
            const destroyBreakpoint = $this.data("destroy-breakpoint") - 1;
            if (destroyBreakpoint) {
                const $window = $(window);

                baseConfig.responsive.push({
                    breakpoint: destroyBreakpoint,
                    settings: "unslick"
                });

                $window.on("resize", debounce(function () {
                    if ($window.width() <= (destroyBreakpoint) && $this.get(0).slick.unslicked) {
                        $this.slick(baseConfig);
                    }
                }));
            }

            $this.slick(baseConfig);
            // Remove empty containers for offline products
            if ($this.hasClass("carousel-product")) {
                const $removeSlides = $this.find(".js-remove-slide");

                if ($removeSlides.length > 0) {
                    $removeSlides.parents(".slide-wrapper").each(function () {
                        let index = $(this).parents(".slick-slide").data("slick-index");
                        $this.slick("slickRemove", index);
                    });
                }
            }

            var nbrSlide = $this.data("slides-small");
            var nbrSlideLarge = $this.data("slides-large");
            if (typeof nbrSlide === "number") {
                if (nbrSlide % 1 !== 0) {
                    $this.parents(".Rn-carousel-wrapper").addClass("floatNumberSlides");
                }
                else {
                    $this.parents(".Rn-carousel-wrapper").addClass("intNumberSlides");
                }
            }
            if (typeof nbrSlideLarge === "number") {
                if (nbrSlideLarge % 1 !== 0) {
                    $this.parents(".Rn-carousel-wrapper").addClass("floatNumberSlides-medium");
                }
            }
        });
    }
};

/**
 * Clear the form errors.
 * @param {string} parentSelector - the parent form selector.
 */
const initFirstCarousel = () => {
    const $carouselWrapper = $(".tab-carousel-wrapper");

    $carouselWrapper.each(function () {
        const $this = $(this);
        const $contentSlider = $this.find(".js-content-tiles-carousel").first();

        if ($contentSlider.length) {
            initCarousel($contentSlider);
        }
    });
};

/**
 * Clear the form errors.
 * @param {string} RnparentSelector - the parent form selector.
 */
const initRnCarousel = () => {
    const $RnCarouselWrapper = $(".Rn-carousel-wrapper");

    $RnCarouselWrapper.each(function () {
        const $this = $(this);
        const $contentSlider = $this.find(".js-content-tiles-carousel").first();

        if ($contentSlider.length) {
            initCarousel($contentSlider);
        }
    });
};

export const initContentTileCarousel = initCarousel;
export const initFirstContentCarousel = initFirstCarousel;
export const initRnContentCarousel = initRnCarousel;
